@let currentUser = user();
@let userWeekCount = weekCount();
@let isPrint = print();
<td class="employee-name">
    <div [title]="currentUser | userDisplayName">{{ currentUser | userDisplayName }}</div>
</td>
<td class="day day-count" [class.warn]="userWeekCount < 5" [title]="userWeekCount | plannedDaysTitle">
    {{ userWeekCount }}
</td>
@for (day of leaveDays(); track day.dayKey; let first = $first) {
    @let userDayKey = day.dayKey | makeKey: currentUser.id;
    @let leaveDayUser = leaveDayUserMap().get(userDayKey);
    @let blockedUser = blockedMap()?.get(userDayKey);
    @let dayUser = dayUserMap().get(userDayKey);
    @let userDayHasConflict = userDayConflictMap().get(userDayKey);
    <td
        class="day"
        [class.night]="userDayHasNightMap().get(userDayKey)"
        [class.text-danger]="userDayHasConflict"
        [attr.data-day]="day.dayKey"
        [attr.title]="
            leaveDayUser
                ? (leaveDayUser.hourtype | hourtype) +
                  (leaveDayUser.comment ? ' - ' + leaveDayUser.comment : '') +
                  (leaveDayUser.afas_project_id ? ' ' + leaveDayUser.afas_project_id : '')
                : null
        "
        [class.first]="first"
        [cdkContextMenuTriggerFor]="contextMenu()"
        (click)="leaveClicked.emit(day.day)"
        (contextmenu)="contextMenuOpened.emit(day.day)">
        <div class="d-flex flex-column">
            @if (leaveDayUser) {
                <i class="fa-regular {{ leaveDayUser.hourtype | hourtypeIcon }}"></i>
            }
            @if (blockedUser) {
                <i class="fa-regular {{ blockedUser.icon }}"></i>
            }
            @if (dayUser) {
                <i class="fa-thin fa-user" [title]="dayUser"></i>
            }
        </div>
    </td>
}
@for (projectDays of projectDays(); track projectDays.rowKey) {
    @for (day of projectDays.days; track day.dayKey; let first = $first) {
        @let userDayKey = day.dayKey | makeKey: currentUser.id;
        @let projectDayUserKey = userDayKey | makeKey: projectDays.rowKey;
        @let projectDayUser = projectDayUserMap().get(projectDayUserKey);
        @let dayUser = dayUserMap().get(userDayKey);
        @let userDayHasConflict = userDayConflictMap().get(userDayKey);
        <td
            class="day"
            [class.night]="projectDayUser | employeeIsNight"
            [attr.data-day]="day.dayKey"
            [attr.data-row-key]="projectDays.rowKey"
            [class.empty]="!day.project?.afas_project_id"
            [class.first]="first"
            [class.text-danger]="userDayHasConflict"
            [class.planned]="!isPrint && dayUser && !projectDayUser"
            (click)="
                projectClicked.emit({
                    event: $event,
                    day,
                    projectDayUser,
                    performerId: projectDays.form.controls.performer_id.value,
                    rowKey: projectDays.rowKey,
                })
            ">
            @if (projectDayUser?.type === 'planning') {
                <i class="fa-light fa-truck"></i>
            } @else if (projectDayUser?.type === 'userPlanning' || projectDayUser?.type === 'project') {
                <i class="fa-light fa-user"></i>
            }
        </td>
    }
}
